import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface SuperAdminRouteProps {
  children: JSX.Element;
}

const SuperAdminRoute = ({ children }: SuperAdminRouteProps) => {
  const { isSuperAdmin } = useAuth();

  if (!isSuperAdmin) {
    return <Navigate to="/super-admin/login" replace />;
  }

  return children;
};

export default SuperAdminRoute;
